const SNAP_MACHINE_NAME = 'a_snap';
const FACEBOOK_MACHINE_NAME = 'a_facebook';
const APPLE_MACHINE_NAME = 'a_apple';
const GOOGLE_ADWORDS_MACHINE_NAME = 'a_google_adwords';
const GOOGLE_DDM_MACHINE_NAME = 'a_google_marketing_platform';
const GOOGLE_ANALYTICS_V4_WEB_MACHINE_NAME = 'di_google_analytics_v4_gtag';
const GOOGLE_ANALYTICS_V4_FIREBASE_MACHINE_NAME = 'di_google_analytics_v4_firebase';
const TWITTER_MACHINE_NAME = 'a_twitter';
const ROKU_MACHINE_NAME = 'a_roku';
const TIKTOK_MACHINE_NAME = 'a_tiktok_ads';
const TIKTOK_SAN_MACHINE_NAME = 'a_tiktok';
const HUAWEI_MACHINE_NAME = 'a_huawei';
const AMAZON_MACHINE_NAME = 'a_amazon';
/**
 * a_yahoo was already taken to supply postback
 * integration for apps during TUNE migration.
 *
 * In order to smooth migration process, we decided to create
 * a separate blueprint for SANs integration.
 *
 * This is why Yahoo's machine is not conventional compare to others
 */
const YAHOO_MACHINE_NAME = 'a_yahoo_san';
const TIKTOK_COMPANY_NAME = 'TikTok';

const SK_AD_NETWORK_SANS_MACHINE_NAMES = [
  SNAP_MACHINE_NAME,
  FACEBOOK_MACHINE_NAME,
  GOOGLE_ADWORDS_MACHINE_NAME,
  TWITTER_MACHINE_NAME,
  TIKTOK_SAN_MACHINE_NAME,
];

const SANS_MACHINE_NAMES = [
  ...SK_AD_NETWORK_SANS_MACHINE_NAMES,
  APPLE_MACHINE_NAME,
  GOOGLE_DDM_MACHINE_NAME,
  ROKU_MACHINE_NAME,
  YAHOO_MACHINE_NAME,
];

/**
 * These partners do not provide Campaign ID in SKAdNetwork message,
 * therefore partner campaign names are used wherever applicable.
 * Soon Twitter will be the first SAN Ad Network with Campaign ID,
 * but at this very moment, it doesn't provide it yet.
 */
const SK_AD_NETWORK_SANS_MACHINES_NAMES_WITH_NO_CAMPAIGN_ID_DATA = [
  SNAP_MACHINE_NAME,
  FACEBOOK_MACHINE_NAME,
  GOOGLE_ADWORDS_MACHINE_NAME,
  TWITTER_MACHINE_NAME,
];

const LOG_SEARCH_MAX_LENGTH = 250;

export {
  SNAP_MACHINE_NAME,
  FACEBOOK_MACHINE_NAME,
  APPLE_MACHINE_NAME,
  GOOGLE_ADWORDS_MACHINE_NAME,
  GOOGLE_DDM_MACHINE_NAME,
  TWITTER_MACHINE_NAME,
  ROKU_MACHINE_NAME,
  TIKTOK_MACHINE_NAME,
  TIKTOK_SAN_MACHINE_NAME,
  YAHOO_MACHINE_NAME,
  SK_AD_NETWORK_SANS_MACHINE_NAMES,
  SANS_MACHINE_NAMES,
  SK_AD_NETWORK_SANS_MACHINES_NAMES_WITH_NO_CAMPAIGN_ID_DATA,
  TIKTOK_COMPANY_NAME,
  HUAWEI_MACHINE_NAME,
  GOOGLE_ANALYTICS_V4_WEB_MACHINE_NAME,
  GOOGLE_ANALYTICS_V4_FIREBASE_MACHINE_NAME,
  AMAZON_MACHINE_NAME,
  LOG_SEARCH_MAX_LENGTH,
};
